
import React from 'react';
import { NavLink } from 'react-router-dom';
import './LegalFooter.css';

const LegalFooter = () => (
  <footer className="legal-footer">
    <NavLink to="/privacy">Privacy Policy</NavLink>
    <span> | </span>
    <NavLink to="/terms">Terms of Service</NavLink>
    <div className="legal-copy">© DayZero Killfeed</div>
  </footer>
);

export default LegalFooter;
